/**
 * Generates a CSV string from bot logs and triggers a browser download.
 *
 * @param {Object} botLogs - The logs object containing an `items` array
 * @param {Array} bots - Array of bot objects for resolving bot titles
 * @param {string} [filename] - Optional filename (defaults to signum_logs_{date}.csv)
 */
export function downloadLogsCsv (botLogs, bots, filename) {
  if (!botLogs?.items || botLogs.items.length === 0) return

  const getBotTitle = (botId) => {
    const bot = bots.find(b => b.id == botId)
    return bot ? bot.title : '-'
  }

  const getAction = (message) => {
    if (message.search('action: buy') > 0) return 'Buy'
    if (message.search('action: sell') > 0) return 'Sell'
    return ''
  }

  const formatDate = (timestamp) => {
    const dateObj = new Date(Date.parse(timestamp))
    return dateObj.toLocaleString(undefined, {
      year: 'numeric', month: 'short', day: '2-digit',
      hour: '2-digit', hour12: false, minute: '2-digit', second: '2-digit'
    })
  }

  const escapeCsvField = (value) => {
    const str = String(value)
    if (str.includes(',') || str.includes('"') || str.includes('\n')) {
      return '"' + str.replace(/"/g, '""') + '"'
    }
    return str
  }

  const maskBotId = (message) => {
    return message.replace(/bot_id:\s*[\w]+/g, 'bot_id: *******')
  }

  const headers = ['Date', 'Bot', 'Action', 'Type', 'Message']
  const rows = botLogs.items.map(log => [
    escapeCsvField(formatDate(log.timestamp)),
    escapeCsvField(getBotTitle(log.botId)),
    escapeCsvField(getAction(log.message)),
    escapeCsvField(log.logLevel),
    escapeCsvField(maskBotId(log.message))
  ])

  const csvContent = [headers.join(','), ...rows.map(r => r.join(','))].join('\n')

  // Trigger browser download
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')

  if (!filename) {
    const now = new Date()
    const dateStr = now.toISOString().slice(0, 10)
    filename = 'signum_logs_' + dateStr + '.csv'
  }

  link.setAttribute('href', url)
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
